import {IGameFilterDefinition} from "../game-filter-definition.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {GameInfo} from "../../../games/game-info";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";

export class OtherGameGroupFilterDefinition implements IGameFilterDefinition {
    constructor(protected readonly services: IServiceFactoryExtended, private gameTypesFilterDefinitions: IGameFilterDefinition[]) {
    }

    get id(): string {
        return "other-game-group";
    }

    readonly subFilters: IGameFilterDefinition[] = [];

    get text(): string {
        return this.services.translation.translate('OTHER');
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        const categoriesInCurrentArena = this.gameTypesFilterDefinitions;
        for(let category of categoriesInCurrentArena) {
          if(category.applyFilter(gameInfo) === ApplyGameFilterResult.IncludeGame) {
            return ApplyGameFilterResult.ExcludeGame;
          }
        }
    
        return ApplyGameFilterResult.IncludeGame;
    }

}